module.exports = "/assets/images/preloader.gif?e34aafbb485a96eaf2a789b2bf3af6fe";